export const API_FETCH_ERROR = "API fetch error.";
export const DATA_ENCRYPTION_FAILED = "There was an issue with encrypting the data.";
export const DATA_SCHEMA_MISMATCH = "Provided data does not match schema.";
export const KEY_CRITERIA_MISMATCH = "No key provided matches criteria.";
export const KEY_RETRIEVAL_FAILED = "Public key retrieval failed.";
export const KEY_WILL_EXPIRE_SOON = "Public key will expire soon.";
export const NO_KEY_CONFIG_MAP_OR_CONFIGS_EXIST = "No keyConfigMap or Configs exist";
export const NO_SCHEMA_PROVIDED = "No schema provided.";
